import { render, staticRenderFns } from "./Polaroid.vue?vue&type=template&id=25043778&scoped=true"
var script = {}
import style0 from "./Polaroid.vue?vue&type=style&index=0&id=25043778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25043778",
  null
  
)

export default component.exports